import { render, staticRenderFns } from "./language-countries.vue?vue&type=template&id=2399eda6&scoped=true&"
import script from "./language-countries.vue?vue&type=script&lang=js&"
export * from "./language-countries.vue?vue&type=script&lang=js&"
import style0 from "./language-countries.vue?vue&type=style&index=0&id=2399eda6&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399eda6",
  null
  
)

component.options.__file = "language-countries.vue"
export default component.exports